import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

export function PrivacyPage() {
  const { t } = useLanguage();

  return (
    <div className="bg-white">
      <div className="max-w-3xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-extrabold text-gray-900">
          {t('privacy.title')}
        </h1>
        
        <div className="mt-8 prose prose-blue">
          <h2 className="font-bold text-gray-800">{t('privacy.introduction.title')}</h2>
          <p>{t('privacy.introduction.content')}</p>

          <h2 className="font-bold text-gray-800">{t('privacy.dataCollection.title')}</h2>
          <p>{t('privacy.dataCollection.content')}</p>

          <h2 className="font-bold text-gray-800">{t('privacy.dataUse.title')}</h2>
          <p>{t('privacy.dataUse.content')}</p>

          <h2 className="font-bold text-gray-800">{t('privacy.cookies.title')}</h2>
          <p>{t('privacy.cookies.content')}</p>

          <h2 className="font-bold text-gray-800">{t('privacy.rights.title')}</h2>
          <p>{t('privacy.rights.content')}</p>

          <h2 className="font-bold text-gray-800">{t('privacy.contact.title')}</h2>
          <p>
            {t('privacy.contact.name')}<br />
            {t('privacy.contact.email')}: info@asena-ug.de<br />
            {t('privacy.contact.phone')}: +49 (0) 40 37 6129 52
          </p>
        </div>
      </div>
    </div>
  );
}